import * as Yup from 'yup';

export default Yup.object().shape({
  interactionDescription: Yup.string().required('Campo obrigatório'),
});
